import React from 'react';
import styled from 'styled-components';
import { ApplicantInformationBox } from './ApplicantInformationBox';
import { ChiefSupervisorContent } from './ChiefSupervisorContent';
import { type ApplicantInfoFormValues } from './type';
import { type NominationModules } from '../../../constants';
import { PAGE_TEXT } from '../../../../Application/components';

type ChiefSupervisorProps = {
  isViewMode?: boolean;
  applicationInfoData: ApplicantInfoFormValues;
  onMoveNext: (activatedId: NominationModules) => void;
  refetchNominationInformation: () => void;
};

export const ChiefSupervisor: React.FC<ChiefSupervisorProps> = props => {
  const {
    applicationInfoData,
    isViewMode = false,
    onMoveNext,
    refetchNominationInformation,
  } = props;

  let applicantInfoValues: ApplicantInfoFormValues = {
    applicationId: '',
    applicantName: '',
    entryYear: '',
    programmeType: '',
    programme: '',
    department: '',
    partnerInstitution: '',
    chiefSupervisorOfPartnerInstitution: '',
    researchArea: '',
    proposedSupervisor: '',
    researchAreaBackup: '',
    proposedChiefSupervisorBackup: '',
    status: '',
  };

  let chiefSupervisorProps = {
    applicationId: '',
    applicantName: '',
    applicationNumber: '',
    status: '',
    applicantId: '',
  };

  const NA = PAGE_TEXT.PROGRAMME_CHOICE.OPTIONS.NO_INDICATION;
  if (applicationInfoData.applicationId !== undefined) {
    const {
      applicationId,
      status,
      applicantName,
      applicantId = '',
      applicationNumber = '',
      proposedSupervisor,
      researchArea,
      researchAreaBackup,
      proposedChiefSupervisorBackup,
    } = applicationInfoData;
    applicantInfoValues = {
      ...applicationInfoData,
      researchArea: researchArea !== '' ? researchArea : NA,
      proposedSupervisor: proposedSupervisor !== '' ? proposedSupervisor : NA,
      researchAreaBackup: researchAreaBackup !== '' ? researchAreaBackup : NA,
      proposedChiefSupervisorBackup:
        proposedChiefSupervisorBackup !== ''
          ? proposedChiefSupervisorBackup
          : NA,
    };
    chiefSupervisorProps = {
      applicationId,
      applicationNumber,
      applicantId,
      applicantName,
      status,
    };
  }

  return (
    <Container>
      <ApplicantInformationBox applicantInfoValues={applicantInfoValues} />
      <ChiefSupervisorContent
        isViewMode={isViewMode}
        applicationInfo={chiefSupervisorProps}
        onMoveNext={onMoveNext}
        refetchNominationInformation={refetchNominationInformation}
      />
    </Container>
  );
};

const Container = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
